import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, ButtonGroup, Flex, Spinner } from '@chakra-ui/react';
import format from 'date-fns/format';

import { ReportState } from 'services/report';
import { parseQueryString } from 'utils';

import Table from 'components/Table';

import MonthPicker from './MonthPicker';
import Row from './Row';

const Monthly = () => {
  const report = useContext(ReportState);
  const [sortMode, setSortMode] = useState('name');

  const month = parseQueryString().m || format(new Date(), 'yyyy-MM');

  useEffect(() => {
    report.fetchMonth(month, sortMode);
    // eslint-disable-next-line
  }, [month, sortMode]);

  return (
    <Box paddingTop="12px" fontSize="14px">
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        <Box />
        <ButtonGroup size="sm" isAttached variant="outline">
          <Button
            colorScheme={sortMode === 'name' ? 'pink' : 'gray'}
            onClick={() => setSortMode('name')}
          >
            Abecedno
          </Button>
          <Button
            colorScheme={sortMode === 'report' ? 'pink' : 'gray'}
            onClick={() => setSortMode('report')}
          >
            Po prioritetu
          </Button>
        </ButtonGroup>
      </Flex>
      <MonthPicker />
      {report.loading ? (
        <Spinner mt={8} color="pink.500" />
      ) : (
        <Table>
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th className="br bl center" colSpan="3">
                Godišnji
              </th>
              <th className="br center" colSpan="2">
                Bolovanje
              </th>
              <th></th>
            </tr>
            <tr>
              <th>Ime</th>
              <th>Norma</th>
              <th className="center bl small">
                Tekući
                <br />
                mjesec
              </th>
              <th className="center small">
                Ukupno
                <br />
                iskorišteno
              </th>
              <th className="center br small">
                Ostalo za
                <br />
                iskoristiti
              </th>
              <th className="center small">
                Ovaj
                <br />
                mjesec
              </th>
              <th className="center br small">
                Zaključno s
                <br />
                ovim mjesecom
              </th>
              <th className="center">Za isplatu</th>
            </tr>
          </thead>
          <tbody>
            {report[month]?.map((w) => (
              <Row key={w.workerId} work={w} />
            ))}
          </tbody>
        </Table>
      )}
    </Box>
  );
};

export default Monthly;
